import React, { useState, useEffect } from 'react';
import '../../assets/css/common.css';
import '../../assets/css/main.css';
import '../../assets/css/adm_custom.css';
import { openAlert, DOC_KIND } from '../../utils/common';
import SectionContainer from '../../components/UI/SectionContainer';
import Pagination from '../../components/UI/Pagination';
import Modal from '../../components/Layout/Modal';
import Spinner from '../../components/UI/Spinner';
import termsService from '../../services/termsService';

const PrivacyHistoryPage = () => {
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [modalLang, setModalLang] = useState('ko');

  const pageSize = 10;
  const pageBlock = 5;

  const fetchHistory = async (page = 1) => {
    setLoading(true);
    try {
      const result = await termsService.getTermsHistory(DOC_KIND.PRIVACY, page, pageSize);
      setHistory(result.items);
      setTotalCount(result.totalCount);
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message || '데이터 로드 중 오류가 발생했습니다.';
      openAlert({ title: '알림', description: errorMessage });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchHistory(currentPage);
  }, [currentPage]);

  const openModal = (item) => {
    setSelectedItem(item);
    setModalLang('ko');
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setSelectedItem(null);
  };

  const handleLangSwitch = (lang) => {
    setModalLang(lang);
  };

  return (
    <SectionContainer title="개인정보 처리방침 히스토리 관리">
      <Spinner visible={loading} />
      <div className="content_area">
        <div className="table_area">
          <div className="table">
            <table>
              <thead>
                <tr>
                  <th style={{ width: '25%' }}>버전</th>
                  <th style={{ width: '50%' }}>상세보기</th>
                  <th style={{ width: '25%' }}>등록일</th>
                </tr>
              </thead>
              <tbody>
                {!loading && history.length === 0 ? (
                  <tr><td colSpan="3">개인정보 처리방침 내역이 존재하지 않습니다.</td></tr>
                ) : (
                  history.map(item => (
                    <tr key={item.idx}>
                      <td>{String(item.version).padStart(2, '0')}</td>
                      <td>
                        <div className="t_but mr-1" style={{ width: '120px', cursor: 'pointer' }} onClick={() => openModal(item)}>
                          내용확인
                        </div>
                      </td>
                      <td>{item.regdate}</td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <Pagination currentPage={currentPage} totalCount={totalCount} pageSize={pageSize} pageBlock={pageBlock} onPageChange={setCurrentPage} />
      <Modal
        title="개인정보 처리방침"
        visible={showModal}
        onConfirm={closeModal}
        modalClassName="terms_wrap bd"
        className="common"
      >
        <div className="lang_tab_area">
          <div className={`lang_tab${modalLang === 'ko' ? ' active' : ''}`} data-lang="ko" onClick={() => handleLangSwitch('ko')}>한국어</div>
          <div className={`lang_tab${modalLang === 'en' ? ' active' : ''}`} data-lang="en" onClick={() => handleLangSwitch('en')}>English</div>
        </div>
        <div className="modal-content-wrap" style={{ overflowY: 'auto', textAlign: 'left' }}>
          <div 
            className={`lang_content${modalLang === 'ko' ? ' active' : ''}`} 
            dangerouslySetInnerHTML={{ 
              __html: selectedItem?.content_ko ? selectedItem.content_ko.replace(/\n/gi, '<br/>') : '한국어 콘텐츠가 없습니다.' 
            }} 
          />
          <div 
            className={`lang_content${modalLang === 'en' ? ' active' : ''}`} 
            dangerouslySetInnerHTML={{ 
              __html: selectedItem?.content_en ? selectedItem.content_en.replace(/\n/gi, '<br/>') : 'No English content available.' 
            }} 
          />
        </div>
      </Modal>
    </SectionContainer>
  );
};

export default PrivacyHistoryPage;
